import { ALLOWED_STATUSES } from '@/postulation_form/components/attached-files/constants';

const AVAILABLE_STATE_STATUS = {
  uploading: 'uploading',
  uploaded: 'uploaded',
  idle: 'idle'
};

export function calculateInitialState(args) {
  return args
    .filter((fileRequirement) =>
      [ALLOWED_STATUSES.required, ALLOWED_STATUSES.optional].includes(fileRequirement.status)
    )
    .map((fileRequirement) => ({
      type: fileRequirement.type,
      isRequired: fileRequirement.status === ALLOWED_STATUSES.required,
      status: 'idle',
      filename: '',
      buttonUploader: ''
    }));
}

function getUpdatedState(params) {
  const { filesList, fileType, filename, status, buttonUploader = '' } = params;

  return filesList.map((file) =>
    file.type === fileType
      ? {
          ...file,
          status: AVAILABLE_STATE_STATUS[status],
          filename,
          buttonUploader
        }
      : file
  );
}

export function attachedFilesReducer(state = [], action) {
  const { type, fileType, filename = '', buttonUploader } = action;

  const isAvailableAction = [
    AVAILABLE_STATE_STATUS.uploaded,
    AVAILABLE_STATE_STATUS.idle,
    AVAILABLE_STATE_STATUS.uploading
  ].includes(type);
  if (!isAvailableAction) {
    throw Error(`Invalid action: ${type} performed`);
  }

  return getUpdatedState({
    filesList: state,
    status: type,
    fileType,
    filename,
    buttonUploader
  });
}
